export default __webpack_public_path__ + "static/media/bendIcon.191d51a0.webp";